import { UPDATE_CARD } from './constants';

export function updateCard(token, opts = {}) {
  return {
    type: UPDATE_CARD,
    token,
    opts,
  };
}
